/* vl-added — the pop-up that answers "Sepete Ekle" everywhere (product pages, the Sitting Cushion landing, the set pages,
   Kalles' own product forms): a native <dialog> with the line just added — photo, name, size, unit price, a quantity stepper
   with a bin, ONE price (the line total with the struck list price above it; the unit price went on 2026-10-16: "the price
   should be mentioned once per product") — the gift pillow(s) the bed brought as one line, and Sepete Git / Satın Al. Owner's
   brief of 2026-10-16 (the İşbir Yatak reference); it replaces the small toast of assets/vl-main-product.js / vl-landing.js / vl-set.js.
   API (window.vlAdded):
     begin(meta)        opens the pop-up in its "adding" state (meta: opener, variant, image, title, list = list price in cents)
     done(resp, meta)   renders from a /cart/add.js answer (an item, or {items: […]}), then re-reads /cart.js
     fail(message)      shows the error inside the pop-up (a string, or Shopify's {description} JSON)
     show(promise, meta) = begin + done / fail;  close();  isOpen()
   The stepper changes the line with /cart/change.js and announces cart:reload like the rest of the theme, so assets/vl-gift.js
   keeps the gift at bed quantity × per bed and the header count follows (cart:count:update). The bin removes the line — the
   gift goes with it through vl-gift — and closes the pop-up. Esc, the ×, a tap outside and the browser's back gesture close it;
   focus returns to the button that opened it. */
(function () {
  'use strict';
  if (window.vlAdded) return;
  var dlg = document.querySelector('dialog[data-vl-added]');
  if (!dlg) return;
  var cfg = {}; try { cfg = JSON.parse(dlg.querySelector('[data-va-cfg]').textContent) || {}; } catch (e) {}
  var html = document.documentElement;
  var body = dlg.querySelector('[data-va-body]'), err = dlg.querySelector('[data-va-err]'), title = dlg.querySelector('[data-va-title]');
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var fill = function (t, m) { return String(t || '').replace(/\{(\w+)\}/g, function (_, k) { return m[k] !== undefined ? m[k] : ''; }); };
  /* money in the store's format (shop.money_format; this store: "{{amount}} ₺" = 1,234.56 ₺) — the same helper as vl-cart-upsell.js */
  var money = function (cents, fmt) {
    fmt = String(fmt || '{{amount}} ₺'); var m = fmt.match(/\{\{\s*(amount[a-z_]*)\s*\}\}/); var key = m ? m[1] : 'amount';
    var dec = /no_decimals/.test(key) ? 0 : 2, thousands = ',', decimal = '.';
    if (/with_comma_separator/.test(key)) { thousands = '.'; decimal = ','; }
    else if (/with_apostrophe_separator/.test(key)) { thousands = "'"; decimal = '.'; }
    else if (/with_period_and_space_separator/.test(key)) { thousands = ' '; decimal = '.'; }
    else if (/with_space_separator/.test(key)) { thousands = ' '; decimal = ','; }
    var n = Math.round(Number(cents) || 0) / 100; var fixed = n.toFixed(dec); var parts = fixed.split('.');
    var intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands); var out = dec ? intp + decimal + parts[1] : intp;
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out).replace(/<[^>]+>/g, '').trim();
  };
  var BIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var st = { key: '', variant: 0, image: '', list: 0, opener: null, timer: 0, busy: false, line: null };
  var isGift = function (it) { return !!(it && it.properties && it.properties._vl_gift_for); };
  var track = function (t, meta) { try { if (window.vlTrack) window.vlTrack.send(t, meta || {}); } catch (e) {} };

  var cleanup = function () {
    html.classList.remove('vl-added-open'); dlg.classList.remove('vl-added--busy', 'vl-added--fail', 'vl-added--wait');
    var o = st.opener; st.opener = null;
    if (o && o.focus && document.contains(o)) { try { o.focus({ preventScroll: true }); } catch (e) {} }
  };
  var open = function (opener) {
    st.opener = opener && opener.focus ? opener : document.activeElement;
    if (!dlg.open) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
    html.classList.add('vl-added-open');
    try { dlg.querySelector('[data-va-close]').focus({ preventScroll: true }); } catch (e) {}
  };
  var close = function () {
    if (dlg.open) { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); cleanup(); } }
    else cleanup();
  };
  dlg.addEventListener('close', cleanup);
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) { close(); return; }            /* the backdrop: a click there is dispatched to the dialog itself */
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    if (t.closest('[data-va-close]')) { close(); return; }
    if (t.closest('[data-va-plus]')) { step(1); return; }
    if (t.closest('[data-va-minus]')) { step(-1); return; }
    if (t.closest('[data-va-remove]')) { remove(); return; }
    if (t.closest('[data-va-buy]')) track('added_buy', { variant: st.variant });
    else if (t.closest('[data-va-cart]')) track('added_cart', { variant: st.variant });
  });

  var setBusy = function (on) { dlg.classList.toggle('vl-added--busy', !!on); };
  var showErr = function (msg) { if (!err) return; var m = msg || cfg.fail || ''; err.textContent = m; err.hidden = !m; };
  var hideErr = function () { if (err) { err.hidden = true; err.textContent = ''; } };
  var msgOf = function (e) { if (!e) return ''; if (typeof e === 'string') return e; return e.description || e.message || ''; };

  var begin = function (meta) {
    meta = meta || {};
    st.key = ''; st.variant = Number(meta.variant) || 0; st.image = meta.image || ''; st.list = Number(meta.list) || 0; st.line = null;
    hideErr(); dlg.classList.remove('vl-added--fail'); setBusy(true);
    if (title) title.textContent = cfg.adding || cfg.title || '';
    body.innerHTML = '<div class="vl-added__busy"><span class="vl-added__spin" aria-hidden="true"></span><span>' + esc(cfg.adding || '') + '</span></div>';
    open(meta.opener);
  };
  var done = function (resp, meta) {
    meta = meta || {};
    var items = resp && resp.items ? resp.items : (resp && resp.key ? [resp] : []);
    var main = items.filter(function (it) { return !isGift(it) && (!st.variant || Number(it.variant_id) === st.variant); })[0] || items.filter(function (it) { return !isGift(it); })[0] || items[0];
    if (!main) { fail(''); return; }
    st.key = main.key; st.variant = Number(main.variant_id) || st.variant;
    if (meta.image) st.image = meta.image; if (meta.list) st.list = Number(meta.list) || 0;
    if (!dlg.open) open(meta.opener);
    render({ items: items, _partial: true });
    refresh();
    track('added_show', { variant: st.variant });
  };
  var fail = function (msg) {
    setBusy(false); dlg.classList.add('vl-added--fail');
    if (title) title.textContent = cfg.fail_title || cfg.title || '';
    if (!st.line) body.innerHTML = '';
    showErr(msgOf(msg));
    if (!dlg.open) open();
  };
  var render = function (cart) {
    var items = cart.items || [];
    var line = items.filter(function (it) { return it.key === st.key; })[0];
    if (!line && st.variant) line = items.filter(function (it) { return !isGift(it) && Number(it.variant_id) === st.variant; })[0];
    if (!line) { if (!cart._partial) close(); return; }        /* the line left the cart (removed elsewhere): nothing to show */
    st.line = line; setBusy(false); dlg.classList.remove('vl-added--fail');
    if (title) title.textContent = cfg.title || '';
    var gifts = items.filter(function (it) { return isGift(it) && String(it.properties._vl_gift_for) === String(line.variant_id); });
    var giftN = gifts.reduce(function (n, g) { return n + (Number(g.quantity) || 0); }, 0);
    var img = st.image || line.image || '';
    var size = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '';
    var unit = Number(line.final_price) || 0;
    var list = st.list > unit ? st.list : (Number(line.original_price) > unit ? Number(line.original_price) : 0);
    body.innerHTML =
      '<div class="vl-added__item">' +
        (img ? '<img class="vl-added__img" src="' + esc(img) + '" alt="" width="96" height="96">' : '<span class="vl-added__img" aria-hidden="true"></span>') +
        '<div class="vl-added__info">' +
          '<p class="vl-added__name">' + esc(line.product_title) + '</p>' +
          (size ? '<p class="vl-added__size">' + esc(size) + '</p>' : '') +
          '<div class="vl-added__qtyrow"><span class="vl-added__label">' + esc(cfg.qty) + ':</span>' +
            '<span class="vl-added__step"><button type="button" data-va-minus aria-label="' + esc(cfg.less || 'Azalt') + '">−</button><output aria-live="polite">' + (Number(line.quantity) || 0) + '</output><button type="button" data-va-plus aria-label="' + esc(cfg.more || 'Artır') + '">+</button></span>' +
            '<button type="button" class="vl-added__bin" data-va-remove aria-label="' + esc(cfg.remove || '') + '">' + BIN + '</button>' +
          '</div>' +
        '</div>' +
        /* one price per product (owner, 2026-10-16): the line total, the struck list price × quantity above it */
        '<div class="vl-added__total"><span class="vl-added__label">' + esc(cfg.total) + '</span><span class="vl-added__sum">' + (list ? '<s class="vl-added__was">' + esc(money(list * (Number(line.quantity) || 1), cfg.money)) + '</s>' : '') + '<span class="vl-added__amount">' + esc(money(Number(line.final_line_price) || 0, cfg.money)) + '</span></span></div>' +
      '</div>' +
      (giftN && cfg.gift ? '<p class="vl-added__gift">' + GIFT + '<span>' + esc(fill(cfg.gift, { adet: giftN, urun: cfg.gift_name || gifts[0].product_title })) + '</span></p>' : '');
  };
  var refresh = function () {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }).catch(function () {});
  };
  var count = function (c) { try { document.dispatchEvent(new CustomEvent('cart:count:update', { detail: { item_count: c.item_count, total_price: c.total_price } })); } catch (e) {} };
  var post = function (url, data) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  };
  var change = function (q) {
    if (!st.line || st.busy) return; st.busy = true; dlg.classList.add('vl-added--wait'); hideErr();
    post('/cart/change.js', { id: st.line.key, quantity: q }).then(function (c) {
      st.busy = false; dlg.classList.remove('vl-added--wait');
      count(c);
      if (q === 0) { track('added_remove', { variant: st.variant }); close(); } else { track('added_qty', { variant: st.variant, qty: q }); render(c); }
      try { document.dispatchEvent(new CustomEvent('cart:reload')); } catch (e) {}
    }).catch(function (e) {
      st.busy = false; dlg.classList.remove('vl-added--wait');
      showErr(msgOf(e)); refresh();
    });
  };
  var step = function (d) { if (!st.line) return; var q = (Number(st.line.quantity) || 0) + d; if (q < 1) { remove(); return; } change(q); };
  var remove = function () { change(0); };
  /* while the pop-up is open, every cart change the theme announces (vl-gift fixing the gift count after a step, a tick on a
     companion row behind the pop-up) repaints it */
  var soon = function () { if (!dlg.open) return; clearTimeout(st.timer); st.timer = setTimeout(function () { if (dlg.open && st.key) refresh(); }, 350); };
  ['cart:reload', 'cart:update', 'cart:refresh'].forEach(function (n) { document.addEventListener(n, soon); });
  /* Kalles' own product forms (quick add, quick view — product-form-component) announce their add with a bubbling cart:update
     whose cartData is the /cart/add.js answer: the same pop-up answers them */
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail; if (!d || d.source !== 'product-form-component' || !d.cartData) return;
    var r = d.cartData; if (!(r.key || (r.items && r.items.length))) return;
    st.variant = 0; st.image = ''; st.list = 0;
    done(r, {});
  });
  window.vlAdded = {
    begin: begin, done: done, fail: fail, close: close, isOpen: function () { return !!dlg.open; },
    show: function (p, meta) { begin(meta); return Promise.resolve(p).then(function (r) { done(r, meta); return r; }, function (e) { fail(e); throw e; }); }
  };
})();
